export enum ContractEngagementType {
  EngagementNew = 'CE - Nouveau contrat',
  EngagementRenewal = 'CE - Renouvellement',
  EngagementResumptionStudies = "CE - Reprise d'études",
  EngegementFollowingSanction = 'CE - Suite sanction',
}

export const labelsByAllContractEngagementType: ContractEngagementType[] = [
  ContractEngagementType.EngagementNew,
  ContractEngagementType.EngagementRenewal,
  ContractEngagementType.EngagementResumptionStudies,
  ContractEngagementType.EngegementFollowingSanction,
];
